/*! @pentacode/ui v0.1.0 */
import { t as e } from "./reduced-motion-CZnc3mB7.js";
import { t } from "./styledElement-DUAqv8gi.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o } from "lit";
import { customElement as s, property as c } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/weather-icon/weather-icon.css.js
var l = n(":host{line-height:0;display:inline-block}:host>img{object-fit:contain;width:1.5em;height:1.5em;filter:var(--darkmode-filter-reversal);display:block}"), u = "/img/weather-icons";
function d(e) {
	u = e;
}
var f = class extends t(a) {
	constructor(...t) {
		super(...t), this.icon = "not-available", this.animated = !1, this.label = "", this._motion = new e(this), this.styles = l;
	}
	render() {
		let e = this.animated && !this._motion.matches ? "animated" : "static", t = `${u}/${e}/${this.icon || "not-available"}.svg`;
		return o`<img src=${t} alt=${this.label} loading="lazy" />`;
	}
};
i([c(), r("design:type", Object)], f.prototype, "icon", void 0), i([c({
	type: Boolean,
	reflect: !0
}), r("design:type", Object)], f.prototype, "animated", void 0), i([c(), r("design:type", Object)], f.prototype, "label", void 0), f = i([s("ptc-ui-weather-icon")], f);
export { d as n, f as t };

//# sourceMappingURL=weather-icon-CYo2v_7U.js.map